import axios from 'axios'

export default {
    namespaced: true,

    state: {
        authenticated: false,
        user: sessionStorage.getItem('user') || null,
        overlay: false,
        dialog: false,
        loginErrors: '',       
        schoolName: process.env.VUE_APP_THEME_SCHOOL, 
    },

    getters: {
        getAuthenticated (state) {
            return state.authenticated
        },

        getUser (state) {
            return state.user
        },

        getOverlay(state){
            return state.overlay
        },

        getDialog(state){
            return state.dialog
        },

        getLoginErrors(state){
            return state.loginErrors
        },       

        getSchoolName (state) {
            return state.schoolName
        }
    },

    mutations: {
        setAuthenticated (state, value) {
            state.authenticated = value
        },

        setUser (state, value) {
            state.user = value
        },    

        setOverlay (state, value){
            state.overlay = value
        },
       
        setDialog(state, value){
            state.dialog = value
        },

        setLoginErrors(state, value){
            state.loginErrors = value
        },     
        
    },

    actions: {
        async signIn ({ commit }, credentials){ 
            try{
                await axios.get('/sanctum/csrf-cookie')
                console.log("authenticating login credentials");
                const { data } = await axios.post('/api/login-student', credentials);
                commit('setUser',JSON.stringify(data));
                sessionStorage.setItem('user', JSON.stringify(data));
                console.log('authenticated');
                commit('setAuthenticated', true);
                //console.log(getters.getAuthenticated);                
            } catch(error){
                error.response ? console.log(error.response) : console.log(error);
                commit('setLoginErrors', error.response.data.message);
                commit('setAuthenticated', false);
                commit('setOverlay', false); 
            }

        },

       
        async signOut({commit}){                       
            await axios.post('/logout')
                    .then(response => {
                        console.log(response);
                    })
            return commit('setAuthenticated', false); 
        },

       checkSession({dispatch}){           
           console.log(`Cookie Set: ${dispatch('cookieSet', 'ans_api_session')}`);
       },
         

       cookieSet(cookieName){
           let name = cookieName + "=";
           let decodedCookie = decodeURIComponent(document.cookie);
           let cookies = decodedCookie.split(';');
           for(var i = 0; i < cookies.length; i++){
               var c = cookies[i];
               while(c.charAt(0) == ' '){
                   c = c.substring(1);
               }
               if(c.indexOf(name) == 0){
                    return true;
               }
           }
           return false;
       }
    }
}